import { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import { Box } from "../../../components/box";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { LabelWithValue } from "../components/label-with-value";
import { openUrl } from "../../../helper/util";
import { documentStatus } from "../../../constants/statusConstants";
import { DocumentService } from "../../../services/document/document.service";
import { CreateNotification } from "../../../components/notifier";
import { useSelector } from "../../../store/store";
import FontFa from "../../../components/fontFa/fontFa";
import { getListIdByStatusValue } from "../../../services/serviceHelper";
import DataGrid, { Column, Export, FilterRow, HeaderFilter, SearchPanel } from "devextreme-react/data-grid";
import { DocumentLinkService } from "../../../services/document/document-link.service";
import { Form, Input, Modal, Spin, Button as AntButton, Space, Typography, Statistic, message } from "antd";
import { Routes } from "../../../AppRoutes";
import { useEmployee, useUser } from "../../../hook";
import { useQueryClient } from "@tanstack/react-query";
import { usePublicDocumentInfo } from "../hooks/published-documents/use-public-documents-info";
import { useHistory } from "react-router-dom";
import { useDocumentTags } from "../../setting/document/document-tags/hooks/useDocumentTags";
import { FileService } from "../../../services/file/file.service";
import { StatisticsEmployeeService } from "../../../services/department-viags/statistics-employee.service";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import saveAs from "file-saver";
import { FileList } from "../../../components";
import { useCheckGroupUser } from "../../../hook/use-check-group-user";
import { DepartmentList } from "../components/document/permission-department/department-list";
import { useMineInfo } from "../../../contexts/mine-info-context";
import PERMISSIONS from "../../../constants/permissions";
import MESSAGES from "../../../constants/messages";

let readTime = Date.now() + 1000 * 60;

export const DocumentInfo = (props: any) => {
  const {
    document,
    toggleEditDetailModal,
    goToPermission,
    isReadOnly,
    isReadOnlyPermission,
    isPublishStatus,
    documentHis,
    isUpdateLoading,
  } = props;
  const user = useSelector((state) => state.user);
  const [readUsers, setReadUsers] = useState<any>([]);
  const [read, setRead] = useState(false);
  const [isShowReadButton, setIsShowReadButton] = useState(false);
  const listId = getListIdByStatusValue(documentStatus.publish.value, false);
  const { userAdmin } = useUser();
  const { isGroupUser, isLoading } = useCheckGroupUser();
  const queryClient = useQueryClient();
  const { data, finalReadUser, countReadUser, totalUser } = usePublicDocumentInfo();
  const [openPermissionModal, setOpenPermissionModal] = useState(false);

  const { checkPermission } = useMineInfo();

  const history = useHistory();
  const { getTagLabel } = useDocumentTags();
  const [form] = Form.useForm();
  const [showCountdown, setShowCountDown] = useState(false);
  const { currentEmployee } = useEmployee();
  const currentUserEmail = user?.current?.username?.toLowerCase();

  const fileAssignedTo: any[] = useMemo(
    () => (document?.fileAssignedTo ? JSON.parse(document.fileAssignedTo) : []),
    [document?.fileAssignedTo],
  );

  const editUser = useMemo(
    () =>
      fileAssignedTo.find(
        (s: { email: string; isEdit: boolean }) => s.email && s.email.toLowerCase() === currentUserEmail && s.isEdit,
      ),
    [currentUserEmail, fileAssignedTo],
  );

  const isEditPermission = useMemo(() => editUser != null, [editUser]);

  const departmentId = useMemo(
    () => (userAdmin && userAdmin.id ? null : editUser?.departmentId),
    [editUser?.departmentId, userAdmin],
  );

  const handleReader = async () => {
    let arrUser: any = [...readUsers];
    let today = new Date();

    const currentUser = {
      id: currentEmployee?.eEmployeeId ?? user.current.localAccountId,
      name: user.current.name,
      email: user.current.username,
      timeRead: today,
    };

    if (arrUser.findIndex((e: any) => e.id === currentUser.id) === -1) {
      arrUser.push(currentUser);
      const fields = {
        docReaders: JSON.stringify(arrUser),
      };
      await DocumentService.updatePulishFileInfo(document?.id, fields);
      await StatisticsEmployeeService.updateUserReadDoc({
        docId: document?.docWorkingId,
        email: currentUser.email,
      });
      queryClient.invalidateQueries({ queryKey: ["document-info"] });
      setRead(!read);
    } else setRead(!read);
  };

  const handleReader_GroupAccount = async ({ userId, userName }: { userId: string; userName: string }) => {
    let arrUser: any = [...readUsers];
    let today = new Date();
    const currentUser = {
      id: userId,
      name: userName,
      email: user.current.username,
      timeRead: today,
    };
    if (arrUser.findIndex((e: any) => e.id === currentUser.id) === -1) {
      arrUser.push(currentUser);
      const fields = {
        docReaders: JSON.stringify(arrUser),
      };
      await DocumentService.updatePulishFileInfo(document?.id, fields);
      await StatisticsEmployeeService.updateUserReadDoc({
        docId: document?.docWorkingId,
        email: currentUser.email,
      });
      queryClient.invalidateQueries({ queryKey: ["document-info"] });

      CreateNotification({
        title: "Xác nhận đã đọc thành công",
        body: "Thông tin anh/chị đã được xác nhận. Xin cảm ơn!",
        icon: "/icons/success.png",
      });
      form.resetFields();
    } else {
      CreateNotification({
        title: "Cập nhật thông tin thất bại",
        body: "Anh/Chị đã đọc tài liệu này!",
        icon: "/icons/warning.png",
      });
    }
  };

  // const onOptionsChange = (e: any) => {
  //   CreateNotification({
  //     title: "Đổi phiên bản thành công",
  //     body: "Thông tin phiên bản được chọn đã được cập nhật!",
  //     icon: "/icons/success.png",
  //   });
  //   setSelectedVersion(e.value);
  //   const newData = versionData.map((e: any) => e.fields);
  //   const docInfo = newData.find(
  //     (docInfo: any) =>
  //       docInfo.docPublicVersion === e.value && docInfo.docUrl.includes("vnPublishDocs") && docInfo.docStatusId === 8
  //   );
  //   docInfo.docPublicDepartment = document.docPublicDepartment;
  //   docInfo.docType = document.docType;
  // };

  const openLink = (docLinkUrl: string, docLinkId: string) => {
    let url = docLinkUrl;
    if (docLinkId) url = Routes.documentDetail.path.replace(":id", docLinkId) + "#link";
    if (url) openUrl(url);
  };

  const setExpired = async () => {
    if (!checkPermission(PERMISSIONS.DELETE_OR_ARCHIVE_DOCUMENT)) return message.error(MESSAGES.NOT_PERMISSION);

    const docId = isPublishStatus ? document.docWorkingId : document.docId;
    const linked = await DocumentLinkService.getDocumentLinkedInfos(docId);
    const linkInfo = await DocumentLinkService.getDocumentLinkInfos(docId);

    if (linkInfo.count > 0) {
      const updateFields = {
        effectiveTo: data?.effectiveFrom,
      };
      linkInfo?.data?.forEach((e: any) => {
        DocumentLinkService.updateDocumentLinkInfo(e.id, updateFields);
      });
    }

    if (linked.count > 0) {
      Modal.confirm({
        title: "Thông báo",
        content: (
          <div>
            <p>Tài liệu đang được liên kết với các tài liệu sau: </p>
            <ol>
              {linked.data.map((e: { id: string; docTitle: string; docUrl: string; docId: string }, index: number) => (
                <li
                  role="button"
                  className="text-primary d-flex row"
                  key={e.id}
                  onClick={() => openLink(e.docUrl, e.docId)}
                >
                  {`${index + 1}. ${e.docTitle}`}
                </li>
              ))}
            </ol>
            <p>Anh/Chị vui lòng xác nhận trước khi đánh dấu lỗi thời?</p>
          </div>
        ),
        okButtonProps: { danger: true },
        onOk: () => {
          isPublishStatus ? handleExpired_PublishStatus(linked.data) : handleExpired(linked.data);
        },
        okText: "Xác nhận",
        cancelText: "Hủy",
        width: 500,
      });
    } else isPublishStatus ? handleExpired_PublishStatus(linked.data) : handleExpired(linked.data);
  };

  const handleExpired = async (linked: any[]) => {
    if (!data) return;
    const fields = {
      effectiveTo: document.effectiveFrom,
    };

    const fieldsUpdateFile = {
      expiredDate: data.effectiveFrom,
      docStatus: "Lỗi thời",
    };

    await DocumentService.updateFileInfo(document.id, fields);
    await DocumentService.updateFileInfo(data.docId, fieldsUpdateFile, listId);
    await FileService.updateFileInfo(data.docWorkingId, { expiredDate: fieldsUpdateFile.expiredDate });
    await DocumentService.updatePulishFileInfo(data.id, fields);

    if (linked.length > 0) {
      const updateFields = {
        docLinkExpiredDate: data.effectiveFrom,
      };
      linked.forEach((e: any) => {
        DocumentLinkService.updateDocumentLinkInfo(e.id, updateFields);
      });
    }

    CreateNotification({ title: "Thành công", body: "Đánh dấu lỗi thời thành công", icon: "/icons/success.png" });
    queryClient.invalidateQueries({ queryKey: ["document-public-info"] });
    queryClient.invalidateQueries({ queryKey: ["document-info"] });
  };

  const handleExpired_PublishStatus = async (linked: any[]) => {
    if (!data) return;

    const fields = {
      effectiveTo: data.effectiveFrom,
    };

    const fieldsUpdateFile = {
      expiredDate: data.effectiveFrom,
      docStatus: "Lỗi thời",
    };

    await DocumentService.updateFileInfo(data.docId, fieldsUpdateFile, listId);
    await DocumentService.updatePulishFileInfo(data.id, fields);

    if (linked.length > 0) {
      const updateFields = {
        docLinkExpiredDate: data.effectiveFrom,
      };
      linked.forEach((e: any) => {
        DocumentLinkService.updateDocumentLinkInfo(e.id, updateFields);
      });
    }

    CreateNotification({ title: "Thành công", body: "Đánh dấu lỗi thời thành công", icon: "/icons/success.png" });
    queryClient.invalidateQueries({ queryKey: ["document-public-info"] });
    queryClient.invalidateQueries({ queryKey: ["document-info"] });
  };

  const handleReadPdf = async () => {
    CreateNotification({
      title: "Thông báo",
      body: "Anh/Chị vui lòng xác nhận sau khi đã đọc tài liệu",
      icon: "/icons/success.png",
    });

    let fileUrl = "";

    if (document.fileId) {
      try {
        const file = await FileService.getFile(document.fileId, listId);
        fileUrl = file.url ?? "";
      } catch (error: any) {
        // fileUrl = document.docUrl;
        console.log(error);
      }
    }

    fileUrl = document.docUrl;

    setTimeout(() => {
      openUrl(isReadOnlyPermission ? fileUrl + "#toolbar=0" : fileUrl);
      setShowCountDown(true);
      readTime = Date.now() + 1000 * 60;
    }, 2500);
  };

  // const getDocumentHistory = () => {
  //   if (document) {
  //     try {
  //       DocumentService.getHistoryDocumentInfo(document?.id)
  //         .then((res) => {
  //           const data = [...new Set(res?.data?.value.map((e: any) => e?.fields?.docPublicVersion))];
  //           setVersionOptions(data.filter((e: any) => e !== 0));
  //           setVersionData(res?.data?.value);
  //         })
  //         .catch((error: any) => console.log(error));
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };

  const isExpired = () => {
    if (!data) return false;
    return data.effectiveFrom === data.effectiveTo;
  };

  const handleRenderRead = (e: any) => {
    return <p>{e.data.read ? "X" : ""}</p>;
  };

  const handleRenderNotRead = (e: any) => {
    return <p>{e.data.read ? "" : "X"}</p>;
  };

  const handleHidePermissionModal = () => {
    setOpenPermissionModal(!openPermissionModal);
  };

  const onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("DanhSachPhanPhoi");

    const customizeCell = (options: any) => {
      const { gridCell, excelCell } = options;

      // Customize only boolean values
      if (gridCell.rowType === "data" && typeof gridCell.value === "boolean") {
        if (gridCell.data.notRead) excelCell.value = gridCell.value ? "X" : "";
        else excelCell.value = gridCell.value ? "✔" : "";
      }
    };

    exportDataGrid({
      component: e.component,
      worksheet,
      topLeftCell: { row: 4, column: 1 },
      customizeCell,
    }).then((cellRange) => {
      // header
      const headerRow = worksheet.getRow(2);
      headerRow.height = 30;
      worksheet.mergeCells(2, 1, 2, 8);

      headerRow.getCell(1).value = "DANH SÁCH PHÂN PHỐI";
      headerRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
      headerRow.getCell(1).alignment = { horizontal: "center" };

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), `DanhSachPhanPhoi_${document.Title}.xlsx`);
      });
    });
  };

  useEffect(() => {
    const docReader = document && document.docReaders ? document.docReaders : [];
    setReadUsers(docReader);
    if (docReader.length > 0) {
      let arrUser: any = [...docReader];
      const currentUser = {
        id: user.current.localAccountId,
        name: user.current.name,
        email: user.current.username,
      };

      if (arrUser.findIndex((e: any) => e.email.toLowerCase() === currentUser.email.toLowerCase()) !== -1)
        setRead(true);
    }
  }, [document, user]);

  const getFolderName = (url: string) => {
    if (!url) return "";
    if (url) {
      const path = new URL(url).pathname;
      const folders = path.split("/");
      // "SecondFolder" will be at index 4 in the folders array
      const secondFolder = folders.slice(-1);
      let startIndex = url.indexOf("vnWorkingDocs/") + "vnWorkingDocs/".length;
      if (isPublishStatus) {
        startIndex = url.indexOf("vnPublishDocs/") + "vnPublishDocs/".length;
      }
      const lastIndex = url.indexOf("/" + secondFolder[0]);
      const subString = url.substring(startIndex, lastIndex);
      return `${decodeURIComponent(subString).replaceAll("/", " ⏵ ")}`;
    }
  };

  const readedPercent = parseFloat(((countReadUser / totalUser) * 100).toFixed(2));
  const unReadPercent = parseFloat((((totalUser - countReadUser) / totalUser) * 100).toFixed(2));

  const AntCountdown = <Statistic.Countdown format="ss" value={readTime} onFinish={() => setIsShowReadButton(true)} />;

  const handlePermission = () => {
    setOpenPermissionModal(!openPermissionModal);
  };

  // const handleMigrate = async () => {
  //   const listIssusedUser = document.docPublicEndUsers
  //     .filter((e: any) => e.email)
  //     .map((e: any) => ({
  //       employeeCode: e.id,
  //       employeeEmail: e.name,
  //       departmentName: e.department,
  //       departmentCode: e.departmentCode,
  //     }));

  //   const fields = {
  //     docId: document.docWorkingId,
  //     docCode: document.docCode,
  //     docName: document.Title,
  //     docType: document.docType,
  //     docStatus: document.docStatus,
  //     publishDay: document.effectiveFrom,
  //     effectiveDate: document.effectiveTo,
  //     isMigration: false,
  //     listIssusedUser: [...listIssusedUser],
  //   };
  //   await StatisticsEmployeeService.addPublishDocForUsers(fields);

  return !document || isUpdateLoading || isLoading ? (
    <Spin />
  ) : (
    <div className="container">
      <div className="head">
        <Col xs="12" className="px-0">
          {/* <Button onClick={() => handleMigrate()}>Đồng bộ</Button> */}
          <div className="d-flex justify-content-end">
            {!isReadOnly && userAdmin && userAdmin.id && (
              <>
                <AntButton className="mr-2 mb-2" onClick={toggleEditDetailModal} type="primary">
                  {"Cập nhật thông tin"}
                </AntButton>
                <AntButton className="mr-2 mb-2" onClick={goToPermission} type="primary">
                  {"Phân quyền kiểm soát tài liệu"}
                </AntButton>
              </>
            )}
            {((isPublishStatus && (read || !isGroupUser) && !document.IsCustomEditor && showCountdown) || read) && (
              <Button
                disabled={read || !isShowReadButton}
                variant={read || !isShowReadButton ? "secondary" : "primary"}
                onClick={handleReader}
                className={"d-flex mb-2 mr-2 justify-content-center align-items-center"}
              >
                {read ? "Anh/Chị đã đọc tài liệu này" : isShowReadButton ? "Tôi Đã đọc" : AntCountdown}
              </Button>
            )}
            {(document?.docStatusId === 8 || document?.docStatusId === 5) && (
              <Fragment>
                {isPublishStatus && !document.IsCustomEditor && (
                  <Button className="mr-2 mb-2 button-info" onClick={handleReadPdf} variant="info">
                    {"Xem tài liệu"}
                  </Button>
                )}
                {!isPublishStatus && userAdmin && userAdmin.id && (
                  <Button
                    className="mr-2 mb-2 button-danger"
                    onClick={setExpired}
                    variant="danger"
                    disabled={isExpired()}
                  >
                    {isExpired() ? "Tài liệu đã lỗi thời" : "Đánh dấu lỗi thời"}
                  </Button>
                )}
                {isPublishStatus && userAdmin && userAdmin.id && (
                  <Button
                    className="mr-2 mb-2 button-danger"
                    onClick={setExpired}
                    variant="danger"
                    disabled={isExpired()}
                  >
                    {isExpired() ? "Tài liệu đã lỗi thời" : "Đánh dấu lỗi thời"}
                  </Button>
                )}
                {((isPublishStatus && isEditPermission) || (isPublishStatus && userAdmin && userAdmin.id)) && (
                  <Button
                    className="mr-2 mb-2 button-danger"
                    variant="primary"
                    title="Triển khai tiếp tài liệu đã được ban hành"
                    onClick={() => handlePermission()}
                  >
                    Triển khai tài liệu
                  </Button>
                )}
              </Fragment>
            )}
          </div>
        </Col>
      </div>
      <Box title={"Thông tin tài liệu"}>
        <Container>
          <Row>
            <Col xs={1} sm={12} md={{ span: 10, offset: 1 }}>
              <div className="document-detail__info py-2 px-5">
                <div className="info-header text-center">
                  <div className="header-text mb-1">{document?.Title}</div>
                  {true && (
                    <span className="mb-5" style={{ fontSize: "11px" }}>
                      <FontFa name="faFolder" color="orange" /> {getFolderName(document?.docUrl)}
                    </span>
                  )}
                </div>

                <div className="info-body"></div>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="card w-100">
          <div className="card-header">Thông tin</div>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <LabelWithValue label={"Mã tài liệu:"} value={document?.docCode} />
                <LabelWithValue label={"Loại tài liệu:"} value={document?.docType} />
                <div className="label-value-item d-flex py-2">
                  <div className="label mr-2">Chủ đề:</div>
                  <div className="value">
                    {document?.Tags?.map((tag: any, index: number) => (
                      <Badge
                        variant="secondary"
                        className="mx-1"
                        key={index}
                        onClick={() => history.push(`/document?status=tags&tags=${tag?.label || tag.toString()}`)}
                      >
                        {getTagLabel(tag)}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <LabelWithValue label={"Bộ phận ban hành:"} value={document?.docPublicDepartment} />
                <LabelWithValue label={"Vị trí:"} value={document?.docOrder} />
                <LabelWithValue label={"Mô tả:"} value={document?.subInfo} />
              </div>
              <div className="col-6">
                <LabelWithValue label={"Tệp đính kèm:"} />
                <FileList files={document?.fileAttachment} />
              </div>
            </div>
          </div>
        </div>

        <div className="card w-100">
          <div className="card-header">Tình trạng</div>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <LabelWithValue label={"Tình trạng:"} value={isExpired() ? "Tài liệu lỗi thời" : document?.docStatus} />
                {/* <LabelWithValue
                 label={(isPublishStatus ? "Ban hành tới:" : "Người thực thi:")}
                 value={document?.fileAssignedTo != "[][]" ? getPeopleDisplay(document?.fileAssignedTo) : null}
              /> */}
              </div>
              <div className="col-6">
                <LabelWithValue label={"Lần sửa đổi:"} value={document?.docEditionVersion || 0} />
              </div>
              <div className="col-6">
                <LabelWithValue label={"Sửa đổi tạm thời:"} value={document?.docEditTemp || ""} />
              </div>
              <div className="col-6">
                <LabelWithValue label={"Lần ban hành:"} value={document?.docPublishViewVersion} />
              </div>
            </div>

            {/* <div className="row">
              {document.IsCustomEditor && (
                <div className="col-6">
                  <LabelWithValue label={"Lần ban hành thứ:"} value={document?.docPublicVersion || 0} />
                </div>
              )}
            </div> */}

            <div className="row">
              <div className="col-6">
                <LabelWithValue
                  label="Thời gian hiệu lực:"
                  value={
                    document?.effectiveFrom && document?.effectiveTo
                      ? `${getDDMMYYYFormat(document.effectiveFrom)} - ${getDDMMYYYFormat(document.effectiveTo)}`
                      : document?.effectiveFrom
                      ? `${getDDMMYYYFormat(document.effectiveFrom)}`
                      : ""
                  }
                />
              </div>
            </div>
            <div className="col-12"></div>
            {isPublishStatus && isGroupUser && showCountdown && (
              <Box className="my-2" title="Khu vực dành cho tài khoản dùng chung VIAGS">
                <Form onFinish={handleReader_GroupAccount} form={form}>
                  <div className="d-flex justify-content-space-around px-2">
                    <Space>
                      <Form.Item
                        name={"userId"}
                        rules={[
                          {
                            required: true,
                            message: `Vui lòng nhập mã nhân viên!`,
                          },
                        ]}
                      >
                        <Input placeholder="Nhập mã nhân viên" />
                      </Form.Item>
                      <Form.Item
                        name={"userName"}
                        rules={[
                          {
                            required: true,
                            message: `Vui lòng nhập tên nhân viên!`,
                          },
                        ]}
                      >
                        <Input placeholder="Nhập tên nhân viên" />
                      </Form.Item>
                      <AntButton
                        disabled={!isShowReadButton}
                        type={!isShowReadButton ? "ghost" : "primary"}
                        htmlType="submit"
                        className={"d-flex mr-2 justify-content-center align-items-center"}
                        style={{ marginBottom: "23px" }}
                      >
                        {isShowReadButton ? "Xác nhận" : AntCountdown}
                      </AntButton>
                    </Space>
                  </div>
                </Form>
              </Box>
            )}
          </div>
        </div>

        <div className="card w-100">
          <div className="card-header">Ý kiến đóng góp</div>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <LabelWithValue
                  label={"Lý do soạn thảo:"}
                  value={documentHis?.find((e: any) => e?.fields?.docStatusValue === "compose")?.fields?.docNotes || ""}
                />
              </div>
              <div className="col-6">
                <LabelWithValue
                  label={"Ý kiến đơn vị soát xét:"}
                  value={document?.docDetectors?.at(0)?.comment || ""}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <LabelWithValue label={"Ý kiến đơn vị kiểm tra:"} value={document?.docCheckers?.at(0)?.comment || ""} />
              </div>
              <div className="col-6">
                <LabelWithValue
                  label={"Ý kiến đơn vị phê duyệt:"}
                  value={document?.docReviewers?.at(0)?.comment || ""}
                />
              </div>
            </div>
          </div>
        </div>
        {isPublishStatus && (
          <div className="card w-100">
            <div className="card-header">Danh sách phân phối</div>
            <div className="card-body">
              <div className="d-flex">
                <div className="d-flex flex-column">
                  <Typography.Text>
                    <span className="font-weight-bold text-muted">Số lượng triển khai: </span> {totalUser}
                  </Typography.Text>
                  <Typography.Text>
                    <span className="font-weight-bold text-muted">Số lượng người đã đọc: </span> {countReadUser}
                  </Typography.Text>
                  <Typography.Text>
                    <span className="font-weight-bold text-muted">Tỷ lệ đã đọc: </span>{" "}
                    {!Number.isNaN(readedPercent) ? readedPercent : 0}%
                  </Typography.Text>
                </div>
                <div className="ml-5 d-flex flex-column">
                  <Typography.Text>
                    <span className="font-weight-bold text-muted">Số lượng người chưa đọc: </span>
                    {totalUser - countReadUser}
                  </Typography.Text>
                  <Typography.Text>
                    <span className="font-weight-bold text-muted">Tỷ lệ chưa đọc: </span>{" "}
                    {!Number.isNaN(unReadPercent) ? unReadPercent : 0}%
                  </Typography.Text>
                </div>
              </div>
              <DataGrid
                id="grid_content"
                noDataText="Không tìm thấy tài liệu"
                dataSource={finalReadUser}
                showBorders={true}
                showRowLines={true}
                allowColumnReordering={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                onExporting={onExporting}
              >
                <SearchPanel visible={true} placeholder="Nhập từ khoá cần tìm" width={300} />
                <FilterRow visible={true} applyFilter={true} />
                <HeaderFilter visible={true} />
                <Export enabled={true} />
                <Column
                  caption="STT"
                  alignment="center"
                  dataField="index"
                  dataType="number"
                  width={60}
                  allowHeaderFiltering={false}
                />
                <Column
                  alignment="center"
                  caption="Mã nhân viên"
                  dataField="employeeId"
                  dataType="string"
                  width={100}
                  allowHeaderFiltering={false}
                />
                <Column
                  caption="Họ và tên"
                  dataField="employeeName"
                  dataType="string"
                  width={160}
                  allowHeaderFiltering={false}
                />
                <Column caption="Cơ quan chi nhánh" dataField="department" dataType="string" />
                <Column caption="Đơn vị" dataField="pDeptCode" dataType="string" />
                <Column
                  alignment="center"
                  caption="Đã đọc tài liệu/văn bản"
                  dataField="read"
                  cellRender={handleRenderRead}
                  dataType="string"
                  width={120}
                  allowFiltering={false}
                  allowHeaderFiltering={true}
                />
                <Column
                  alignment="center"
                  caption="Chưa đọc tài liệu/văn bản"
                  dataField="notRead"
                  dataType="string"
                  allowHeaderFiltering={false}
                  cellRender={handleRenderNotRead}
                  allowFiltering={false}
                  width={100}
                />
                <Column
                  caption="Ghi chú"
                  dataField="GHICHUTHOIGIAN"
                  dataType="string"
                  width={160}
                  allowHeaderFiltering={false}
                />
              </DataGrid>
            </div>
          </div>
        )}
      </Box>

      <DepartmentList
        id={document?.id}
        title={document.Title}
        listId={listId}
        isDocumentLibrary={true}
        isOpen={openPermissionModal}
        onClose={handleHidePermissionModal}
        document={document}
        isPublishStatus={true}
        isAddMore={true}
        departmentId={departmentId}
      />
    </div>
  );
};
